import { ArrowCollapseAllIcon } from './ArrowCollapseAllIcon';

/**
 * author: Austin Andrews
 * id 54364780-8F31-4B23-8085-ABE21EA55926
 * name arrow-collapse-all
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-collapse-all.svg
 * tags
 * - Arrow 
 */
export const ArrowCompressAllIcon = ArrowCollapseAllIcon;
export default ArrowCompressAllIcon